import Vue from "vue/dist/vue.esm";
import "./modal.scss";
import { axiosInstance as axios } from "./axios-instance";
import ImageCropper from "./components/ImageCropper.vue";

document.addEventListener("DOMContentLoaded", () => {
  const topicsSelect = document.querySelector("#topics");

  new Vue({
    el: "#app",
    data: {
      isNavMenuOpen: false,
      isModalVisible: false,
      userEmail: "",
      isSubscribed: false,
      newsletterName: (document.querySelector("#newsletter_name") || {}).value || "",
      newsletterUrl: (document.querySelector("#newsletter_url") || {}).value || "",
      tagLine: (document.querySelector("#newsletter_tagline") || {}).value || "",
      logoPreviewUrl: "",
      selectedTopics: Array.from((topicsSelect || {}).selectedOptions || []).map((option) => option.value),
      selectedUpgrade: (document.querySelector("input[name='upgrade_type']:checked") || {}).value || "",
      submissionStep: Number(((document.querySelector("[data-newsletter-submission-form]") || {}).dataset || {}).initialStep || 1),
    },
    mounted() {
      window.addEventListener("newsletter-logo-cropped", (event) => {
        this.logoPreviewUrl = event.detail.imageUrl;
      });
    },
    methods: {
      alertMe: () => {
        alert("Vue function!");
      },
      openNewTab: (url) => {
        window.open(url, "_blank");
      },
      redirectTo: (event, url) => {
        if (["A", "BUTTON"].includes(event.target.nodeName)) {
          return;
        }
        window.location.href = url;
      },
      closeParent: (event) => {
        const element = event.target;
        const closeTarget = element.closest(".close-target");
        closeTarget.parentElement.removeChild(closeTarget);
      },
      validateSubmissionStep: function (stepNumber) {
        const step = document.querySelector(`[data-submission-step='${stepNumber}']`);
        if (!step) return true;
        const fields = Array.from(step.querySelectorAll("input, textarea, select"));
        const invalidField = fields.find((field) => !field.checkValidity());

        if (invalidField) {
          invalidField.reportValidity();
          return false;
        }

        return true;
      },
      goToSponsorshipStep: function () {
        if (!this.validateSubmissionStep(1)) {
          return;
        }

        this.submissionStep = 2;
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      goToUpgradeStep: function () {
        if (!this.validateSubmissionStep(2)) {
          return;
        }

        this.submissionStep = 3;
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      goToBasicSubmissionStep: function () {
        this.submissionStep = 1;
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      goToSponsorshipStepWithoutValidation: function () {
        this.submissionStep = 2;
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      handleNewsletterSubmission: function (event) {
        if (this.submissionStep === 3) {
          return;
        }

        event.preventDefault();
        if (this.submissionStep === 1) {
          this.goToSponsorshipStep();
        } else {
          this.goToUpgradeStep();
        }
      },
      subscribeUserEmail: function () {
        axios
          .post("/subscribe-email", {
            email: this.userEmail,
          })
          .then(() => {
            this.userEmail = "";
            this.isSubscribed = true;
          })
          .catch((res) => {
            console.warn(res);
          });
      },
    },
  });
  console.log("Vue app initialized — #app");

  new Vue({
    el: "#image-cropper",
    components: {
      ImageCropper, // Register the component
    },
    template: `<ImageCropper />`, // Use the component in the app
  });
  console.log("Vue app initialized — #image-cropper");
});
